import React from "react";
import { MoreVertical } from "react-feather";
/**
 * 
 * @param {options} 
 * Options Schema ==========
 * const options = [
    {
      name: "",
      onClick: () => null,
    },
  ];
  ===========================
 * @returns <ActionMenu/>
 */

const ActionMenu = ({
  name = "Actions",
  options = [
    {
      name: "Default Item",
      show: true,
      onClick: () => null,
    },
  ],
}) => {
  return (
    <div className="dropdown">
      <button
        className="btn btn-light px-2"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span className="text-capitalize">{name}</span>
        <MoreVertical color="grey" size={12} />
      </button>
      <ul className="dropdown-menu shadow rounded-3">
        {options.map(({ name, onClick, show = true }, index) => {
          return (
            <>
              {show ? (
                <li key={name} className="text-capitalize">
                  <a className="dropdown-item py-2 " onClick={onClick}>
                    {name}
                  </a>
                </li>
              ) : null}
            </>
          );
        })}
      </ul>
    </div>
  );
};

export { ActionMenu };
